import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Villas from "./components/Villas";
import Services from "./components/Services";
import Roadmap from "./components/Roadmap";
import Location from "./components/Location";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

// New pages
import BigVilla from "./pages/BigVilla";
import MediumVilla from "./pages/MediumVilla";
import ChilloutZone from "./pages/ChilloutZone";
import Concierge from "./pages/Concierge";
import ParkGarden from "./pages/ParkGarden";
import Overview from "./components/Overview";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Homepage */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Overview />
              <Villas />
              <Features />
              <Services />
              <Roadmap />
              <Location />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* Villa Pages */}
        <Route path="/villa/big" element={<BigVilla />} />
        <Route path="/villa/medium" element={<MediumVilla />} />
        <Route path="/villa/chillout" element={<ChilloutZone />} />
        <Route path="/villa/concierge" element={<Concierge />} />
        <Route path="/villa/park" element={<ParkGarden />} />
      </Routes>
    </Router>
  );
}

export default App;
